/**
 * Severity chip: pale tinted ground, saturated text of the matching hue.
 *
 * This is how BlueSphere shows status everywhere — a soft background with
 * a strong dot and label, rather than a solid saturated block. The old
 * MDR card used a filled pill with white text, which shouted at a glance
 * and made a list of detections read as a row of warning lights.
 */

import clsx from 'clsx';

import { SEVERITY_COLORS, SEVERITY_TINTS } from './tokens.js';

export interface SeverityChipProps {
  severity: string;
  /** Show the leading dot. Off for very dense rows. */
  dot?: boolean;
  className?: string;
}

export function SeverityChip({ severity, dot = true, className }: SeverityChipProps) {
  const color = SEVERITY_COLORS[severity] ?? '#6B7280';
  const tint = SEVERITY_TINTS[severity] ?? '#F1F2F4';

  return (
    <span
      className={clsx('bs-chip', className)}
      style={{ backgroundColor: tint, color: '#2A3241' }}
    >
      {dot && (
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
      )}
      {severity}
    </span>
  );
}
